import { H5 } from '@oneflare/flarekit/lib/components';
import H2 from '@oneflare/flarekit/lib/components/H2';
import H3 from '@oneflare/flarekit/lib/components/H3';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled, css, ExecutionContext } from 'styled-components';

import { publicRuntimeConfig } from 'lib/utils/Environment';

// The font stack below is used on oneflare pages in order to improve CLS score.
// This is because the system font Tahoma has a similar width to Montserratbold,
// which results in less of a layout shift when the browser switches fonts on load.
const clsFontStack = 'Tahoma, \'Helvetica Neue\', Arial, sans-serif';

const isOneflareDomain = publicRuntimeConfig.DOMAIN === 'oneflare';

const SubTitleStyles = css`
  color: ${({ theme }) => theme.color.white};
  font-size: 36px;
  font-weight: 100;
  margin: 0;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.75) 0 2px 4px;
  font-family: ${({ theme }) => (isOneflareDomain ? clsFontStack : theme.font.primaryRegular)};

  ${({ $removeBackground, theme }: ExecutionContext & {
    $removeBackground?: boolean;
  }) => ($removeBackground
    ? `color: ${theme.color.charcoal};
      text-shadow: none;`
    : `color: ${theme.color.white};
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.75);`)
  }

  ${media.smUp`
    color: ${({ theme }) => theme.color.white};
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.75);
    font-size: 50px;
 `}
`;

export const SubTitleH2Styled = styled(H2)<{
  $removeBackground?: boolean;
}>`
  ${SubTitleStyles}
`;

export const SubTitleH3Styled = styled(H3)<{
  $removeBackground?: boolean;
}>`
  ${SubTitleStyles}
`;

export const SubTitleH5Styled = styled(H5)`
  margin: 0;
  font-size: 18px;
  font-family: ${({ theme }) => theme.font.primaryRegular};
  color: ${({ theme }) => theme.color.charcoal};
  text-align: center;
  max-width: 416px;

  ${media.smUp`
    font-family: ${({ theme }) => theme.font.secondaryBold};
    color: ${({ theme }) => theme.color.white};
    max-width: 1120px;
  `}
`;
